module.exports = __webpack_public_path__ + "img/me_inactive.7d7ea096.svg";